import React, { CSSProperties, ReactNode } from 'react';

import Grid from '@mui/material/Grid2';

export interface CenteredProps {
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
}

const Centered = (props: CenteredProps) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="space-around"
      className={props.className}
      style={{
        height: '100%',
        justifySelf: 'center',
        ...props.style
      }}
    >
      <Grid container direction="row" justifyContent="space-around">
        <Grid>{props.children}</Grid>
      </Grid>
    </Grid>
  );
};

export default Centered;
